import { HStack, Text, VStack } from '@chakra-ui/react'
import { FieldTypes, TextField } from '@hb/shared'
import { TotpMultiFactorInfo } from 'firebase/auth'
import { useEffect } from 'react'
import { useAuthenticatorVerify } from '../../../hooks/backend/auth/useAuthenticatorVerify'
import { SolidActionButton } from '../../Buttons'
import { CollapseError } from '../../CollapseError'
import { StandaloneInput } from '../../forms/Input'

const codeField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Verification Code',
}

export const AuthenticatorVerify = ({ factor }: { factor: TotpMultiFactorInfo }) => {
  const { code, setCode, verifying, error, handleVerify } = useAuthenticatorVerify({ factor })

  useEffect(() => {
    const onEnter = (e: KeyboardEvent) => {
      e.stopPropagation()
      if (e.key === 'Enter') {
        handleVerify()
      }
    }

    window.addEventListener('keydown', onEnter)
    return () => window.removeEventListener('keydown', onEnter)
  }, [handleVerify])

  return (
    <VStack px={1} w="100%" align="flex-start">
      <VStack align="flex-start" w="100%" p={1}>
        <Text>Enter the code on your authenticator app:</Text>
        <StandaloneInput theme="detailed" field={codeField} value={code} onChange={setCode} />
        <CollapseError error={error} />
        <HStack w="100%">
          <SolidActionButton isLoading={verifying} ml="auto" onClick={handleVerify}>
            Verify
          </SolidActionButton>
        </HStack>
      </VStack>
    </VStack>
  )
}
